<template>
  <div class="floor-help">
    <el-tabs v-model="activeName">
      <el-tab-pane label="用户评价" name="0">
        <ModUserComment></ModUserComment>
      </el-tab-pane>
      <el-tab-pane label="专业检测" name="1">
        <div class="mod-check">
          <img class="icon-check" src="//s1.huishoubao.com/static/pc/1001/img/evaluate-testing.jpg">
        </div>
      </el-tab-pane>
      <el-tab-pane label="隐私保护" name="2">
        <ModPrivacy></ModPrivacy>
      </el-tab-pane>
      <el-tab-pane label="回收流程" name="3">
        <div class="mod-recycle-process">
          <img src="//s1.huishoubao.com/static/pc/1001/img/user-evaluation.jpg">
        </div>
      </el-tab-pane>
      <el-tab-pane label="猜你要问" name="4">
        <div class="mod-question">
          <dl>
            <dt>Q: 我提交订单的价格是不是最终回收价？</dt>
            <dd>A: 手机实际情况和订单信息一致，我们会按照订单上的回收价和您交易，目前我们98%的订单都是原价交易，如果检测结果有差异，价格会有一定浮动，我们会主动联系您确认价格，若您不接受价格，我们会将手机包邮退回（山寨机、高仿机、有锁机和iCloud账户未注销除外）。</dd>
            <dt>Q: 快递费是谁承担，标准是多少？</dt>
            <dd>A: 请优先选择顺丰邮寄您的手机，如实描述手机真实状态，回收宝承担寄来运费（22元封顶），不承担保价费；如果您的区域无法使用顺丰，则可以选用其他快递方式，请先垫付运费，回收宝在收到您的手机后会将您实际支付的运费补贴给您，22元封顶。如果您出售的是二手笔记本，回收宝承担的运费标准为40元封顶。</dd>
            <dt>Q: 回收手机后多久收到款项？</dt>
            <dd>A: 收到手机之后(以快递签收时间为准)，我们会在24小时内完成检测并且给您付款的，如遇到包裹量特别大的情况可能会有延迟，但是都会尽快去做处理。</dd>
          </dl>
          <a href="javacript:void(0);" class="more-question" @click="showServicePopup=true">更多问题&nbsp;&gt;</a>
        </div>
      </el-tab-pane>
    </el-tabs>
    <ServicePopup v-model="showServicePopup"></ServicePopup>
  </div>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';
import ModPrivacy from './mod-privacy';
import ModUserComment from './mod-user-comment';
import ServicePopup from '../../components/service-popup';

export default {
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    ModPrivacy,
    ModUserComment,
    ServicePopup
  },
  data () {
    return {
      activeName: '0',
      showServicePopup: false
    };
  }
};
</script>

<style scoped>
.floor-help {
  background-color: #fff;
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
  /deep/ .el-tabs__item {
    height: 50px;
    line-height: 50px;
  }
  /deep/ .el-tabs__nav {
    width: 100%;
  }
  /deep/ .el-tabs__item {
    width: 20%;
    text-align: center;
  }
}

.mod-check {
  padding-top: 40px;
  padding-bottom: 40px;
  .icon-check {
    width: 100%;
  }
}

.mod-question {
  line-height: 24px;
  padding: 0 40px;
  padding-bottom: 40px;
  color: #666;
  dt {
    font-size: 16px;
    margin-top: 40px;
  }
  dd {
    font-size: 14px;
    line-height: 28px;
    margin-top: 10px;
    color: #999;
  }
  .more-question {
    display: block;
    margin-top: 20px;
    color: #3782ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/evInfo/floor-help.vue